import React from 'react';
import './LandingPage.css';
import { centralHeatingJpg as landingHeroBg } from '../images/assets';

const WHATSAPP_NUMBER = '201001787846';
const WHATSAPP_PREFILL = 'مرحباً، أود الحصول على عرض سعر مجاني';

function LandingPage() {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_PREFILL
  )}`;

  return (
    <div className="landing-page" dir="rtl" lang="ar">
      <div
        className="landing-hero"
        style={{
          backgroundImage: `url(${landingHeroBg}), linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)`,
        }}
      >
        <div className="landing-overlay" />
        <div className="landing-content">
          <h1 className="landing-headline">حلول تدفئة احترافية لمنزلك</h1>
          <p className="landing-subheadline">
            التدفئة المركزية، تسخين المياه بالطاقة الشمسية، تدفئة المسابح والمياه الساخنة المنزلية.
            تركيب وصيانة احترافية في مصر.
          </p>
          <ul className="landing-benefits">
            <li>معدات ذات جودة وتركيب احترافي</li>
            <li>استشارة مجانية وعروض أسعار واضحة</li>
            <li>ثقة العملاء والشركات</li>
          </ul>
          <div className="landing-offer">
            عرض خاص: مع أي صفقة تدفئة مركزية احصل على سخان مياه مركزي ٢٠٠ لتر مجاناً
          </div>
          <a
            href={whatsappUrl}
            className="landing-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            احصل على عرض سعر مجاني
          </a>
          <p className="landing-trust">
            تواصل معنا: <a href="tel:01001787846" className="landing-phone">01001787846</a> • Info@globalheating.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
